// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".src-components-Backdrop-Backdrop__backdrop--Dm80Z{position:fixed;width:100%;height:100%;will-change:opacity;pointer-events:none}", ""]);
// Exports
exports.locals = {
	"backdrop": "src-components-Backdrop-Backdrop__backdrop--Dm80Z"
};
module.exports = exports;
